import React from "react"

import classes from "./Container.module.scss"
import clsx from "clsx"

const Container = ({ children, className, ...otherProps }) => (
  <div
    className={clsx(classes["container"],
      !!className && className
    )}
    {...otherProps}
  >
    {children}
  </div>
)

export default Container